import { NavItem, SiteConfig } from "@/types"

export const siteConfig: SiteConfig = {
  name: "Moya Fertility",
  description: "Moya Fertility - Fertility Care and Support",
  links: {
    facebook: "https://facebook.com/Moyafertility",
    instagram: "https://instagram.com/Moyafertility",
  },
}

export const navItems: NavItem[] = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "About",
    href: "/about",
  },
  {
    title: "Services",
    href: "/services",
    children: [
      {
        title: "Our Services",
        href: "/services",
      },
      {
        title: "Pricing",
        href: "/services/pricing",
      },
    ],
  },
  {
    title: "Patient Stories",
    href: "/testimonials",
  },
  {
    title: "Patient Info",
    href: "/patient-info",
  },
  {
    title: "Resources",
    href: "#",
    children: [
      {
        title: "FAQ",
        href: "/faq",
      },
    ],
  },
  {
    title: "Contact",
    href: "/contact",
  },
] 